
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface InfoDialogData {
  /**
   * Dialog title
   */
  title: string;
  /**
   * Dialog information text
   */
  infoText: string;
  /**
   * Optional dialog additional text (2nd paragraph)
   */
  additionalText?: string;
  /**
   * Dialog button text
   */
  btnText: string;
}

@Component({
    selector: 'app-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss'],
    imports: [
    MatDialogModule,
    MatButtonModule
],
    providers: [
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true } }
    ]
})
export class InfoDialogComponent  {
  dialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);
  data = inject<InfoDialogData>(MAT_DIALOG_DATA);


  constructor() {
    const data = this.data;

    this.data = data;
  }
}